import {
  getBrowserBridgeAPI as getBrowserBridgeAPIBase,
  type createRovoBridgeAPIClient,
  type RovoContentBridgeAPI,
} from '@atlassian/rovo-content-bridge-api';

export * from '@atlassian/rovo-content-bridge-api';

/**
 * The public interface shape of the Rovo Content Bridge API.
 * Extracted from the return type of {@link createRovoBridgeAPIClient}.
 */
export type RovoContentBridgeAPIShape = ReturnType<typeof createRovoBridgeAPIClient>;

export const getBrowserBridgeAPI = (): RovoContentBridgeAPI => {
  if (globalThis.ATLASSIAN_CANVAS?.mockBridgeAPI === undefined) {
    return getBrowserBridgeAPIBase();
  } else {
    return globalThis.ATLASSIAN_CANVAS.mockBridgeAPI;
  }
};
